module.exports = __webpack_public_path__ + "media/images/icons/icon-certificate-62b95dc639bd43d4fae2d5ecbe081af3.svg";